module.exports = __webpack_public_path__ + "img/Azad-Uni.1e476e9.webp";